import React from 'react';

import { Assignee } from 'api/queries/getTopStartDateChanges.query';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import classes from 'components/common/Tables/Cells/DisplayAvatarListWithHiddenItemCell/DisplayAvatarListWithHiddenItemCell.module.scss';
import { DisplayListOfAvatarsCell } from 'components/common/Tables/Cells/DisplayAvatarListWithHiddenItemCell/components/DisplayListOfAvatarsCell';

export const DisplayAvatarListWithHiddenItemCell = ({
    avatarList,
    maxNumberToDisplay,
}: {
    avatarList: Assignee[];
    maxNumberToDisplay?: number;
}) => {
    return (
        <div className={classes.container}>
            <div className={classes.avatarListWrapper}>
                <DisplayListOfAvatarsCell avatarList={avatarList} maxNumberToDisplay={maxNumberToDisplay} />
            </div>

            {maxNumberToDisplay && avatarList.length - maxNumberToDisplay > 0 && (
                <DisplayHiddenAvatar extraNumber={avatarList.length - maxNumberToDisplay} />
            )}
        </div>
    );
};

const DisplayHiddenAvatar = ({ extraNumber }: { extraNumber: number }) => {
    return (
        <CustomizedTooltip
            tooltipContent={`+${extraNumber}`}
            triggerElement={
                <span className={classes.extraItemsDisplay} data-testid={'extraItemsDisplay'}>{`+${extraNumber}`}</span>
            }
        />
    );
};
